import { SpinnerContainer } from '@superbet-group/web.lib.ui-components';
import { defineAsyncComponent } from '@vue/composition-api';
import { AsyncComponent } from 'vue';

export function withLoadingSpinner(asyncComponentLoader: () => Promise<any>): AsyncComponent {
    return defineAsyncComponent({
        loader: asyncComponentLoader,
        loadingComponent: SpinnerContainer,
    });
}
